export default __webpack_public_path__ + "static/media/Confetti-Doodles.433ace5d.svg";